import { colors } from "@/styles/styleVariables";
 
import { type ThemeOptions } from "@mui/material/styles/createTheme";

export const muiPalette: ThemeOptions["palette"] = {
  primary: {
    main: colors.white,
  },
};
